/**
 * TypeaheadService - Interface to get typeahead data from ares and also a center point to return back a UI type ahead model
 */
var TypeaheadService = /** @class */ (function () {
    function TypeaheadService($http, Util, $q, ProductService, SearchService, RecommendedProductsService, $state, $window) {
        'ngInject';
        this.typeaheadMinCharactersAllowedToSearch = 1;
        this.$http = $http;
        this.handleSuccess = Util.handleSuccess;
        this.handleError = Util.handleError;
        this.$q = $q;
        this.ProductService = ProductService;
        this.SearchService = SearchService;
        this.RecommendedProductsService = RecommendedProductsService;
        this.$state = $state;
        this.$window = $window;
    }
    /**
     * allowedToRequest -
     * @param {string} searchTerm
     * @return {boolean}
     */
    TypeaheadService.prototype.allowedToRequest = function (searchTerm) {
        return searchTerm.length >= this.typeaheadMinCharactersAllowedToSearch;
    };
    /**
     * typeahead - Makes request to get the type ahead and also builds a model to return to UI
     * @param {string} searchTerm
     * @return {promise}
     */
    TypeaheadService.prototype.typeaheadRecommendedProductPreview = function (searchTerm) {
        var _this = this;
        return this.$http.post('api/typeahead/search/' + searchTerm)
            .then(function (results) {
            if (results.data.errors.length > 0) {
                return _this.$q.reject(results.data.errors[0]);
            }
            return results.data.response;
        })
            .catch(function (error) {
            return _this.$q.reject(error);
        });
    };
    /**
     * addNewTypeaheadItemModels - Basic model for the type ahead
     * @param {string} wordType
     * @param {string} wordValue
     * @param {boolean} isFirst
     * @param {string} url - the search url this typeahead item should create
     * @param {function} onClickFunction - function to handle the on click and execute a search
     * @return {{word: *, wordType: *, isFirst: *, onClickSearchFunction: *}}
     */
    TypeaheadService.prototype.addNewTypeaheadItemModels = function (wordType, wordValue, isFirst, url, onClickFunction) {
        return {
            word: wordValue,
            wordType: wordType,
            isFirst: isFirst,
            url: url,
            onClickSearchFunction: onClickFunction,
            recommendedProducts: this.RecommendedProductsService.getRequestModel(wordValue),
        };
    };
    /**
     * addTypeaheadItemModels - builds the typeahead model for filter type typeahead
     * @param {string} typeaheadDisplayName - text to display for the typeahead
     * @param {array} values - array of strings for the current typeahead type
     * @param {object} typeaheadModel - array model to build onto that will be returned to the caller
     * @param {string} filterType - categories, conditions, brands
     * @param {boolean} searchWithFilter - if search should search be performed with a filter
     * @param {string} searchTermValue - Search term value
     */
    TypeaheadService.prototype.addTypeaheadItemModels = function (typeaheadDisplayName, values, typeaheadModel, filterType, searchWithFilter, searchTermValue) {
        var _this = this;
        var _loop_1 = function (x) {
            if (searchWithFilter) {
                var type = filterType === 'brands' ? 'b' : filterType === 'categories' ? 'c' : 'd';
                var state_1 = {
                    term: searchTermValue,
                    ff: values[x].id,
                    fft: type
                };
                state_1[type] = values[x].id;
                var url = this_1.$state.href('advSearchResults', state_1, { inherit: false });
                var newSubItem = this_1.addNewTypeaheadItemModels(typeaheadDisplayName, values[x].value, (x === 0), url, function () {
                    _this.SearchService.clickedSearchTerm = values[x].value;
                    _this.$state.go('advSearchResults', state_1);
                });
                typeaheadModel.push(newSubItem);
            }
            else {
                var searchTerm = values[x];
                var state_2 = {
                    term: searchTerm,
                    ff: searchTerm,
                    fft: 'term'
                };
                var url = this_1.$state.href('advSearchResults', state_2, { inherit: false });
                var newSubItem = this_1.addNewTypeaheadItemModels(typeaheadDisplayName, values[x], (x === 0), url, function () {
                    _this.SearchService.clickedSearchTerm = values[x];
                    _this.$state.go('advSearchResults', state_2);
                });
                typeaheadModel.push(newSubItem);
            }
        };
        var this_1 = this;
        for (var x = 0; x < values.length; x++) {
            _loop_1(x);
        }
    };
    /**
     * createTypeaheadItemsModel - build the typeahead model, its pretty geared towards the UI for now,
     * we could pull this out to live on its own.
     * @param {object} data - typeahead data
     * @return {array}
     */
    TypeaheadService.prototype.createTypeaheadItemsModel = function (data) {
        var typeaheadModel = [];
        var facets = data.facets;
        var searchSuggestions = data.searchTermSuggestions;
        var spellingSuggestions = data.spellingSuggestions;
        var searchTerm = data.searchTerm;
        // Add suggested spelling and search terms first
        this.addTypeaheadItemModels('Spelling Suggestions', spellingSuggestions, typeaheadModel, null, false);
        this.addTypeaheadItemModels('Search Terms', searchSuggestions, typeaheadModel, null, false);
        // The search request and api responses for filter types are different. Make sure to use the SearchService filter
        // types which is the single point for this definition for now.
        this.addTypeaheadItemModels('Categories', facets['Categories'] || [], typeaheadModel, 'categories', true, searchTerm);
        this.addTypeaheadItemModels('Conditions', facets['Conditions'] || [], typeaheadModel, 'conditions', true, searchTerm);
        this.addTypeaheadItemModels('Brands', facets['Brand'] || [], typeaheadModel, 'brands', true, searchTerm);
        return typeaheadModel;
    };
    TypeaheadService.prototype.mapFacets = function (data) {
        var _this = this;
        return this.$q.all([
            this.ProductService.getBrands(),
            this.ProductService.getCategories(),
            this.ProductService.getConditionTaxonomies(),
        ])
            .then(function (responses) {
            var mappedFacets = {
                facets: {
                    Brand: [],
                    Categories: [],
                    Conditions: [],
                },
            };
            mappedFacets.facets.Brand =
                _this.createMappedFacetList(data.facets.Brand, responses[0].currentPage, 'brandId', 'brand');
            mappedFacets.facets.Categories =
                _this.createMappedFacetList(data.facets.Categories, responses[1], 'taxonomyId', 'category');
            mappedFacets.facets.Conditions =
                _this.createMappedFacetList(data.facets.Conditions, responses[2], 'taxonomyId', 'displayName');
            mappedFacets = Object.assign(data, mappedFacets); // keep searchTerm and spelling suggestions and replace facets
            return mappedFacets;
        })
            .catch(function () { return _this.$q.reject(); });
    };
    /**
     * Returns an array of a specified property type after matching facets between the passed in data sets
     * @param {Array<String>} facetDataList - facet id data to be found
     * @param {Array<Object>} facetToFindList - list of facets to search against
     * @param {String} propToSearch - the facet object property to match against (i.e. 'id')
     * @param {String} propToPush - the facet object property value to push into the array (i.e. 'name')
     * @return {Array}
     */
    TypeaheadService.prototype.createMappedFacetList = function (facetDataList, facetToFindList, propToSearch, propToPush) {
        var facets = [];
        if (facetDataList && facetDataList.length) {
            facetDataList.forEach(function (item) {
                var facet = facetToFindList.find(function (facetItem) { return item === facetItem[propToSearch].toString(); });
                if (facet) {
                    facets.push({ id: item, value: facet[propToPush] });
                }
            });
        }
        return facets;
    };
    /**
     * typeahead - Makes request to get the type ahead and also builds a model to return to UI
     * @param {string} searchTerm
     * @return {promise}
     */
    TypeaheadService.prototype.typeahead = function (searchTerm) {
        var _this = this;
        var deferred = this.$q.defer();
        var searchTermValue = searchTerm;
        if (!this.allowedToRequest(searchTerm)) {
            deferred.reject('The search terms character length is less than the minimum characters to make the request!');
            return deferred.promise;
        }
        this.$http.get('api/typeahead/' + this.$window.encodeURIComponent(searchTerm), { cache: true })
            .then(function (results) {
            if (results.data.errors.length > 0) {
                return deferred.reject(results.data.errors[0]);
            }
            _this.mapFacets(results.data.response)
                .then(function (mappedFacets) {
                mappedFacets.searchTerm = searchTermValue ? searchTermValue : '*';
                var model = _this.createTypeaheadItemsModel(mappedFacets);
                return deferred.resolve(model);
            })
                .catch(function () { return deferred.reject(); });
        })
            .catch(function (error) {
            return deferred.reject(error);
        });
        return deferred.promise;
    };
    TypeaheadService.prototype.typeaheadSearch = function (searchTerm) {
        return this.typeaheadRecommendedProductPreview(searchTerm);
    };
    return TypeaheadService;
}());
export { TypeaheadService };
//# sourceMappingURL=typeahead.service.js.map